







import { defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { shareUrl } from "@/lib/urlHelpers";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "Share",

  components: { BaseIcon, BaseButton },
  props: {
    copyText: String,
    notificationText: { type: String, default: $t("Link copied") },
    showCaption: { type: Boolean, default: false },
    iconSize: { type: String },
  },
  setup(props, ctx) {
    const { copyText = `${window.location.origin}${ctx.root.$route.path}`, notificationText } = props;
    const click = () => shareUrl(copyText, notificationText);
    return { click };
  },
});
